export interface SocialLink {
  title: string;
  link: string;
}

export const SOCIAL_LINKS_DATA: SocialLink[] = [
  {
    title: "Facebook",
    link: "#",
  },
  {
    title: "Instagram",
    link: "#",
  },
  {
    title: "Twitter",
    link: "#",
  },
]; 